import { useEffect, useState } from 'react';
import { useEsStrings } from './EsStrings';

/**
 * Full screen for the whole page, beside the palette button.
 *
 * <p>The icon follows document.fullscreenElement through a fullscreenchange
 * listener rather than the click, because Esc and F11 leave full screen without
 * touching this button. Renders nothing where the API is absent (iPhone Safari).
 */
export default function EsFullscreenToggler() {
    const t = useEsStrings();
    const [ full, setFull ] = useState( () => !!document.fullscreenElement );

    useEffect( () => {
        const aSync = () => setFull( !!document.fullscreenElement );
        document.addEventListener( 'fullscreenchange', aSync );
        return () => document.removeEventListener( 'fullscreenchange', aSync );
    }, [] );

    if ( !document.fullscreenEnabled ) {
        return null;
    }

    // A refusal (no user gesture, a policy) leaves the page as it was; nothing to report.
    const aToggle = () => {
        const aDone = document.fullscreenElement
            ? document.exitFullscreen()
            : document.documentElement.requestFullscreen();
        aDone.catch( () => {} );
    };

    const aLabel = full ? t( 'common-fullscreen-exit', 'Exit full screen' ) : t( 'common-fullscreen-enter', 'Full screen' );

    return (
        <div>
            <button
                type="button"
                data-testid="es-nav-fullscreen"
                aria-label={ aLabel }
                title={ aLabel }
                onClick={ aToggle }
                className="esNavDisc ms-1 flex sm:ms-2 cursor-pointer items-center justify-center rounded-full text-nav-glyph bg-nav-disc">
                <i className={ ( full ? 'pi pi-window-minimize' : 'pi pi-window-maximize' ) + ' text-lg leading-none' } />
            </button>
        </div>
    );
}
